var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"l-tt-buy-button c-tt-buy-button",class:_vm.enabledClass,on:{"click":_vm.action}},[_vm._v(" "+_vm._s(_vm.isLocked ? "Requires an Eternity to unlock" : _vm.formatCost(_vm.cost))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }